module.exports = {"pathContext":{"slug":"/en/suggestions/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-suggestions.json
// module id = 1181
// module chunks = 103303225716578